define("shared/types/plans", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.PlanInterval = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let PlanInterval = _exports.PlanInterval = /*#__PURE__*/function (PlanInterval) {
    PlanInterval["Monthly"] = "monthly";
    PlanInterval["Yearly"] = "yearly";
    return PlanInterval;
  }({});
});